import AppService from './AppService';

export const getMachines = () => {
  return AppService.get('/machine').then(({ data }) => data);
};
export default {
  getMachines,
};
